import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import faqIcon from '../../images/faqIcon.png'
import Navbar from '../../Components/Navbar'
import Footer from '../../Components/Footer'
import faqs from './faqs'
import asa from './asa'
import spirit from './spirit'
import CookieConsentComponent from '../../Components/CookieConsent'

import './faq.css'

export default class Faq extends Component {
    constructor() {
        super();
          this.state = {
          fillBackground: false,
          activeFaq: 0,
          heightGeral: '200px',
          heightAsa: '0px',
          heightSpirit: '0px',
          activeTopic: 'geral'
        };
      }

    componentDidMount() {
        window.scrollTo(0,0);
        window.addEventListener('scroll', this.handleWindowScroll, true)
        if(window.innerWidth <= 767) {
            this.setState({
                heightGeral: '1200px'
            })
        } else {
            this.setState({
                heightGeral: '200px'
            })
        }
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleWindowScroll, true)
    }

    handleWindowScroll = () => {
        this.setState({
            fillBackground: window.scrollY > 100
        })
    }

    handleClick(e) {
        let id = e.target.id
        this.setState({
            activeFaq: id
        })
    }

    handleTopic(e) {
        let id = e.target.id
        let height
        if(window.innerWidth <= 767) {
            height = '1200px'
        } else {
            height = '200px'
        }
        if(this.state.activeTopic === id){
            this.setState({
                activeTopic: 'none',
                heightGeral: '0px',
                heightAsa: '0px',
                heightSpirit: '0px',
                activeFaq: 0
            })
        } else {
            this.setState({
                activeTopic: id,
                activeFaq: 0
            })
            if(id === 'geral'){
                this.setState({
                    heightGeral: height,
                    heightAsa: '0px',
                    heightSpirit: '0px'
                })
            } else if(id === 'asa'){
                this.setState({
                    heightAsa: height,
                    heightGeral: '0px',
                    heightSpirit: '0px'
                })
            } else {
                this.setState({
                    heightSpirit: height,
                    heightAsa: '0px',
                    heightGeral: '0px'
                })
            }
        }
    }
      
    render() {
        return (
            <>
                <Navbar/>
                    <div className="section faqWrapper headerWrapper">
                        <Container className="h-100">
                            <Row className="h-100">
                                <Col md={12}>
                                    <h6 className="preTitle tx-pink">Suporte</h6>
                                    <h2 className="pageCall tx-darker text-left">Independente da sua dúvida<br /> <span className="tx-pink">estamos aqui para ajudar</span>.</h2>
                                </Col>
                            </Row>
                        </Container>
                    </div>
                    <div className="section insideSec perguntasSec">
                        <Container>
                            <Row>
                                <Col md={5} className="faqLeft">
                                    <h6 className="subTitle tx-darker"><img alt="Ícone FAQ" width="5%" src={faqIcon} className="mr-2 img-fluid" />Perguntas frequentes</h6>
                                    <hr />
                                    <div className={"topic mt-3 " + (this.state.activeTopic === "geral" ? 'topicActive': '')}>
                                        <label id="geral" onClick={(e) => this.handleTopic(e)}>Dúvidas Gerais</label>
                                        <div className="topicContent" style={{maxHeight: this.state.heightGeral, overflow: 'hidden', transitionDuration: '0.5s'}}>
                                            {faqs.map(faq => {
                                                return <button onClick={(e) => this.handleClick(e)} id={faq.id} className={"faqBtn " + (faq.id === this.state.activeFaq ? 'faqBtnActive' : '')}>{faq.title}</button>
                                                })}
                                            <hr />
                                            {this.state.activeTopic === 'geral' ? (
                                                <div className="mobileAnswer">
                                                    <h4 className="pageTitle tx-darker text-left faqTitle">{faqs[this.state.activeFaq]["title"]}</h4>
                                                    <div 
                                                        className="faqContent"
                                                        dangerouslySetInnerHTML={{ __html: faqs[this.state.activeFaq]["content"] }}
                                                    />
                                                </div>
                                            ) : ''}
                                        </div>
                                    </div>
                                    <div className={"topic mt-3 " + (this.state.activeTopic === "asa" ? 'topicActive': '')}>
                                        <label id="asa" onClick={(e) => this.handleTopic(e)}>Dúvidas Flow Digital Assets ASA</label>
                                        <div className="topicContent" style={{maxHeight: this.state.heightAsa, overflow: 'hidden', transitionDuration: '0.5s'}}>
                                            {asa.map(faq => {
                                                return <button onClick={(e) => this.handleClick(e)} id={faq.id} className={"faqBtn " + (faq.id === this.state.activeFaq ? 'faqBtnActive' : '')}>{faq.title}</button>
                                                })}
                                            {this.state.activeTopic === 'asa' ? (
                                                <div className="mobileAnswer">
                                                    <h4 className="pageTitle tx-darker text-left faqTitle">{asa[this.state.activeFaq]["title"]}</h4>
                                                    <div 
                                                        className="faqContent"
                                                        dangerouslySetInnerHTML={{ __html: asa[this.state.activeFaq]["content"] }}
                                                    />
                                                </div>
                                            ) : ''}
                                        </div>
                                    </div>
                                    <div className={"topic mt-3 " + (this.state.activeTopic === "spirit" ? 'topicActive': '')}>
                                        <label id="spirit" onClick={(e) => this.handleTopic(e)}>Dúvidas Flow Digital Assets Spirit</label>
                                        <div className="topicContent" style={{maxHeight: this.state.heightSpirit, overflow: 'hidden', transitionDuration: '0.5s'}}>
                                            {spirit.map(faq => {
                                                return <button onClick={(e) => this.handleClick(e)} id={faq.id} className={"faqBtn " + (faq.id === this.state.activeFaq ? 'faqBtnActive' : '')}>{faq.title}</button>
                                                })}
                                            {this.state.activeTopic === 'spirit' ? (
                                                <div className="mobileAnswer">
                                                    <h4 className="pageTitle tx-darker text-left faqTitle">{spirit[this.state.activeFaq]["title"]}</h4>
                                                    <div 
                                                        className="faqContent"
                                                        dangerouslySetInnerHTML={{ __html: spirit[this.state.activeFaq]["content"] }}
                                                    />
                                                </div>
                                            ) : ''}
                                        </div>
                                    </div>
                                    <div className="d-flex w-100 faqBottom align-items-center justify-content-between">
                                        <p className="tx-light-pink mb-0">Não encontrou<br />sua dúvida aqui?</p>
                                        <Link to="/suporte" className="tx-pink btnFaqBottom">Entre em Contato</Link>
                                    </div>
                                </Col>
                                <Col md={1}></Col>
                                <Col md={6} className="faqRight">
                                    <hr />
                                    {this.state.activeTopic === 'geral' ? (
                                        <div>
                                            <h4 className="pageTitle tx-darker text-left faqTitle">{faqs[this.state.activeFaq]["title"]}</h4>
                                            <div 
                                               className="faqContent"
                                               dangerouslySetInnerHTML={{ __html: faqs[this.state.activeFaq]["content"] }}
                                            />  
                                             </div>   
                                    ) : ''}
                                    {this.state.activeTopic === 'asa' ? (
                                        <div>
                                            <h4 className="pageTitle tx-darker text-left faqTitle">{asa[this.state.activeFaq]["title"]}</h4>
                                            <div 
                                               className="faqContent"
                                               dangerouslySetInnerHTML={{ __html: asa[this.state.activeFaq]["content"] }}
                                            />  
                                             </div>   
                                    ) : ''}
                                    {this.state.activeTopic === 'spirit' ? (
                                        <div>
                                            <h4 className="pageTitle tx-darker text-left faqTitle">{spirit[this.state.activeFaq]["title"]}</h4>
                                            <div 
                                               className="faqContent"
                                               dangerouslySetInnerHTML={{ __html: spirit[this.state.activeFaq]["content"] }}
                                            />  
                                             </div>   
                                    ) : ''}
                                </Col>
                            </Row>
                        </Container>
                    </div>
                    <CookieConsentComponent />
                <Footer />
            </>
        )
    }
}